// extracted by mini-css-extract-plugin
export default {"Tabs":"styles_Tabs__RxYYG","tab":"styles_tab__DnJqt","active":"styles_active__XnwsS"};